import { gql } from '@apollo/client';

export const RECOMMENDED_LOCATION_QUERY = gql`
  query {
    recommendedLocations {
      items {
        termId
        imageUrl
        locationType
        locationName
        locationSlug
        parentName
        parentSlug
        condoCount
        detachedHouseCount
        townHomeCount
      }
    }
  }
`;

export interface RecommendedLocationQueryResponse {
  recommendedLocations: { items: RecommendedLocation[] };
}

export type RecommendedLocation = {
  termId: number;
  imageUrl: string;
  locationType: string;
  locationName: string;
  locationSlug: string;
  parentName: string;
  parentSlug: string;
  condoCount: number;
  detachedHouseCount: number;
  townHomeCount: number;
};
